import React, { useState } from 'react';
import { Col, Card, CardBody, ListGroup, ListGroupItem } from 'reactstrap';

export const CardNestedList = ({ title, icon, history, subItems }) => {
  const [openDropdown, setOpenDropdown] = useState(false);

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  return (
    <Card>
      <CardBody className="p-3">
        <ListGroup className="nested-list nested-sortable">
          <ListGroupItem className="nested-1">
            <i className={`${icon} fs-16 align-middle text-primary me-2`}></i>{' '}
            {title}
            {subItems.map(
              ({ subtitle, route, action, dropdownActions }, index) => (
                <ListGroupItem
                  key={index}
                  className={`nested-2 card-animate ${
                    index === 1 && openDropdown ? 'open' : ''
                  }`}
                  style={{
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (index === 1) {
                      toggleDropdown();
                    } else {
                      history.push(route);
                    }
                  }}
                >
                  <span className="user-select-none">{subtitle}</span>
                  {index === 1 && openDropdown && (
                    <ListGroup className="nested-list nested-sortable">
                      {dropdownActions.map(
                        ({ label, onClick }, dropdownIndex) => (
                          <ListGroupItem
                            key={dropdownIndex}
                            className="nested-3"
                            style={{
                              cursor: 'pointer',
                            }}
                            onClick={onClick}
                          >
                            {label}
                          </ListGroupItem>
                        )
                      )}
                    </ListGroup>
                  )}
                </ListGroupItem>
              )
            )}
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </Card>
  );
};
